export default $(document).ready(e => {
    const $radioButtons = $('input[type=radio][name=select_segment]');
    var container = $("#select_objektart");
    container.hide();

    $radioButtons.change(e => {
        e.preventDefault();
        console.log(e.target.value);

        var selectedValue = e.target.value;
        if (selectedValue === "Wohnen") {
            container.addClass("animate__fadeIn").show();
        } else {
            container.hide().removeClass("animate__fadeIn");
        }
    })
})
